export default {
  __async: true,
  UserModel: () => import('./UserModel'),
  PassportModel: () => import('./PassportModel'),
};
